import { queryContractList,insertContract,deleteContract } from "../../api/config/modules/ContractManagement";

const state = {
    queryContractList: {},
    insertContract: {},
    deleteContract: {},
};

const mutations = {
  SET_QUERYCONTRACT: (state, queryContractList) => {
    state.queryContractList = queryContractList;
  },
  SET_INSERTCONTRACT: (state, insertContract) => {
    state.insertContract = insertContract;
  },
  SET_DELETECONTRACT: (state, deleteContract) => {
    state.deleteContract = deleteContract;
  },
};

const actions = {
  GET_QUERYCONTRACT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        queryContractList(data)
        .then((res) => {
          commit("SET_QUERYCONTRACT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTCONTRACT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertContract(data)
        .then((res) => {
          commit("SET_INSERTCONTRACT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETECONTRACT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteContract(data)
        .then((res) => {
          commit("SET_DELETECONTRACT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
